export const BUSINESS = {
  name: "Rosto's",
  payoff: "L'arte del pollo arrosto marinato al forno",
  tagline: "Laboratorio di pollo arrosto gourmet — Roma, Garbatella",
  phoneDisplay: "+39 392 35 55 502",
  phoneLink: "+393923555502",
  email: "ciao@rostos.it",
  address: "Via Giuseppe Candeo 16",
  city: "00154 Roma · Garbatella",
  hours: [
    { days: "Martedì – Domenica", time: "12:00 – 15:00 · 18:00 – 22:00" },
    { days: "Lunedì", time: "18:00 – 22:00" },
  ],
  hoursShort: "Mar–Dom 12–15 / 18–22 · Lun 18–22",
  links: {
    glovo: "https://glovoapp.com/it/it/roma/rostos-garbatella/",
    justeat: "https://www.justeat.it/restaurants-rostos-roma",
    deliveroo: "https://deliveroo.it/it/menu/rome/garbatella/rostos",
    whatsapp: "https://wa.me/393923555502",
    instagram: "https://instagram.com/rostosofficial",
    facebook: "https://www.facebook.com/share/1E57yk14w5/?mibextid=wwXIfr",
    tiktok: "https://www.tiktok.com/@rostosofficial",
    googleReview:
      "https://www.google.com/search?q=Rosto%27s+rosticceria+Garbatella+Roma",
    mapsLink:
      "https://www.google.com/maps/search/?api=1&query=Via+Giuseppe+Candeo+16%2C+00154+Roma+Garbatella",
    mapsEmbed:
      "https://www.google.com/maps?q=Via+Giuseppe+Candeo+16%2C+00154+Roma&z=17&output=embed",
  },
};

export const MENU = [
  {
    id: "combo-mezzo",
    title: "Combo Mezzo Pollo + Patate",
    eyebrow: "Pranzo veloce",
    price: "12,90",
    description:
      "Mezzo pollo arrosto Campese + patate al forno regular. Il combo da asporto più richiesto della rosticceria: pronto, completo, generoso.",
    items: ["Mezzo pollo Campese", "Patate al forno regular"],
    image: "/mezzo-pollo.jpg",
  },
  {
    id: "combo-intero",
    title: "Combo Intero + Patate",
    eyebrow: "Da condividere",
    price: "19,90",
    description:
      "Pollo Campese intero arrosto + patate al forno large. La cena di Garbatella che mette tutti d'accordo, perfetta anche in delivery a Roma.",
    items: ["Pollo Campese intero", "Patate al forno large"],
    image: "/pollo-intero.jpg",
    featured: true,
  },
  {
    id: "alette",
    title: "Alette ROSTO'S",
    eyebrow: "Lab signature",
    price: "7,50",
    sizes: [
      { label: "6 pz", price: "7,50" },
      { label: "9 pz", price: "10,50" },
    ],
    description:
      "Alette di pollo Campese marinate 24-48h, cotte al forno e glassate piccanti o al miele. La nostra alternativa al fritto: stesso piacere, più sapore.",
    items: ["Alette di pollo Campese", "Glassa piccante o al miele", "Cottura al forno"],
    image: "/alette-piccanti.jpg",
  },
  {
    id: "nuggets",
    title: "Nuggets ROSTO'S",
    eyebrow: "Per tutti",
    price: "6,90",
    sizes: [
      { label: "6 pz", price: "6,90" },
      { label: "9 pz", price: "9,90" },
    ],
    description:
      "Bocconcini di pollo impanati a mano e cotti croccanti. Perfetti per i più piccoli e per chi cerca un comfort food onesto.",
    items: ["Pollo a bocconcini", "Panatura artigianale", "Salse della casa"],
    image: "/nuggets.jpg",
  },
];

export const QUALITY = [
  {
    icon: "Feather",
    title: "Allevato all'aperto",
    description:
      "Polli italiani da filiera selezionata, cresciuti senza fretta — niente scorciatoie.",
  },
  {
    icon: "Leaf",
    title: "Marinatura mediterranea",
    description:
      "24 ore di olio EVO, agrumi, erbe e spezie. Il sapore arriva da sé.",
  },
  {
    icon: "Flame",
    title: "Cotto al forno, lento",
    description:
      "Pelle dorata, polpa che resta succosa. Solo fuoco, tempo e pazienza.",
  },
  {
    icon: "MapPin",
    title: "Cuore Garbatella",
    description:
      "Un laboratorio di quartiere: ricette nostre, mani vere, prezzi giusti.",
  },
];

export const ORDER_OPTIONS = [
  {
    id: "glovo",
    title: "Glovo",
    description: "Consegna in 30 min",
    cta: "Ordina su Glovo",
    href: BUSINESS.links.glovo,
    accent: "ember",
  },
  {
    id: "justeat",
    title: "Just Eat",
    description: "Consegna a domicilio",
    cta: "Ordina su Just Eat",
    href: BUSINESS.links.justeat,
    accent: "copper",
  },
  {
    id: "phone",
    title: "Telefono",
    description: BUSINESS.phoneDisplay,
    cta: "Chiama ora",
    href: `tel:${BUSINESS.phoneLink}`,
    accent: "outline",
  },
  {
    id: "pickup",
    title: "Ritiro in negozio",
    description: "Pronto in 15 min",
    cta: "Apri in mappa",
    href: BUSINESS.links.mapsLink,
    accent: "outline",
  },
];
